function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Button } from '../../../../components/action/Button';
import { useBreakpoint } from '../../../../theme';
import { Group } from '../../../Group';
import { BaseModal } from '../../BaseModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var StatusModalFooter = _ref => {
  var {
    primaryButton,
    secondaryButton,
    children,
    isCriticalVariant
  } = _ref;
  var {
    isExtraSmallScreen: isMobile
  } = useBreakpoint();
  var showButtons = !!primaryButton || !!secondaryButton;
  return /*#__PURE__*/_jsx(BaseModal.Footer, {
    children: (showButtons || children) && /*#__PURE__*/_jsxs(Group, {
      variant: "vertical",
      children: [showButtons && /*#__PURE__*/_jsxs(Group, {
        spacing: "s",
        variant: isMobile ? 'vertical' : 'horizontal',
        justifyContent: "flex-end",
        children: [secondaryButton && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, secondaryButton), {}, {
          "data-testid": "modal-btn-secondary",
          isFullWidth: !primaryButton,
          size: isMobile ? 'large' : 'medium'
        })), primaryButton && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, primaryButton), {}, {
          "data-testid": "modal-btn-primary",
          variant: isCriticalVariant ? 'critical' : primaryButton.variant,
          onClick: primaryButton.onClick,
          label: primaryButton.label,
          isFullWidth: !secondaryButton,
          size: isMobile ? 'large' : 'medium'
        }))]
      }), children]
    })
  });
};
StatusModalFooter.displayName = 'StatusModalFooter';
//# sourceMappingURL=StatusModalFooter.js.map